'use client'

import UIFlex from '@components/ui/UIFlex'
import UIText from '@components/ui/UIText'
import { useDarkModeControl } from '@hooks/useDarkModeControl'
import color from '@ui/style/color.theme'
import { pxToRem } from '@ui/style/muiTheme'

interface NoCommentProps {
	targetName: string
}
const NoComment = ({ targetName }: NoCommentProps) => {
	const { darkMode } = useDarkModeControl()
	return (
		<UIFlex
			className="print-hide"
			height={pxToRem(124)}
			px={pxToRem(20)}
			py={pxToRem(32)}
			bgcolor={darkMode ? '#3F3F3F' : color.colGray1}
			border={`1px solid ${darkMode ? '#4F4F4F' : color.colGray3}`}
			borderRadius="4px"
			justifyContent="center"
		>
			<UIText
				textAlign="center"
				fontSize={pxToRem(15)}
				lineHeight={pxToRem(20)}
				letterSpacing="-0.7px"
				fontWeight={500}
				color={darkMode ? color.colGray5 : '#aaa'}
			>
				JTBC 댓글 정책에 따라
				<br />이 {targetName}에서는 댓글을 제공하지 않습니다.
			</UIText>
		</UIFlex>
	)
}

export default NoComment
